import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {environment} from '@environments/environment';
import {BehaviorSubject, Observable, throwError} from 'rxjs';
import {QueryParamsModel} from '@core/models/query-models/query-params.model';
import {QueryResultsModel} from '@core/models/query-models/query-results.model';
import {catchError, finalize, map} from 'rxjs/operators';
import {DeliveryReturnModel} from '../_models/deliveryReturn.model';
import {HttpUtilsService} from '@core/utils/http-utils.service';

@Injectable({
    providedIn: 'root'
})
export class DeliveryReturnService {
    API_URL = `${environment.api_host}/api/delivery/returns/`;

    // tslint:disable-next-line:variable-name
    private _isLoading$ = new BehaviorSubject<boolean>(false);

    constructor(private http: HttpClient, private httpUtils: HttpUtilsService) {
    }

    get isLoading$() {
        return this._isLoading$.asObservable();
    }

    findDeliveryReturns(queryParams?: QueryParamsModel): Observable<QueryResultsModel<DeliveryReturnModel>> {
        this._isLoading$.next(true);
        const offset = queryParams ? queryParams.pageNumber * queryParams.pageSize : 0;
        const limit = queryParams ? queryParams.pageSize : 100;

        let params = new HttpParams();
        if ( queryParams?.filter) {
            params = new HttpParams({fromObject: queryParams?.filter});
        }

        const url = this.API_URL + `list/${limit}/${offset}`;
        return this.http.get<QueryResultsModel<DeliveryReturnModel>>(url, {params}).pipe(
            map((res: QueryResultsModel<DeliveryReturnModel>) => {
                const queryResults = new QueryResultsModel<DeliveryReturnModel>();
                queryResults.results = res.results;
                queryResults.total = res.total;
                return queryResults;
            }),
            finalize(() => this._isLoading$.next(false))
        );
    }

    createDeliveryReturn(deliveryReturn: DeliveryReturnModel) {
        this._isLoading$.next(true);
        const url = this.API_URL + `create`;
        const httpHeaders = this.httpUtils.getHTTPHeaders();
        return this.http.post<DeliveryReturnModel>(url, deliveryReturn.saveToAPI(), {headers: httpHeaders}).pipe(
            catchError(err => {
                console.error('CREATE ITEM', err.error);
                return throwError(err);
            }),
            finalize(() => this._isLoading$.next(false))
        );
    }

    getItemById(id: number ): Observable<DeliveryReturnModel>{
        this._isLoading$.next(true);
        const url = this.API_URL + `show/${id}`;
        return this.http.get<DeliveryReturnModel>(url).pipe(
            catchError(err => {
                // this._errorMessage.next(err);
                console.error('GET ITEM BY IT', id, err);
                return throwError(err);
            }),
            finalize(() => this._isLoading$.next(false))
        );
    }
}
